{% block sw_dashboard_index_content_intro_card %}
    {% parent %}
    <sw-dashboard-statistics-promotion-card />
{% endblock %}
